import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTranslationUi } from 'hooks/useTranslationUi';
import useSingleExtrastockOffer from '../useSingleExtrastockOffer';
import { getExtrastockOfferViewSections } from '../extrastockOfferViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleExtrastockOffer = () => {
  const { t } = useTranslation();
  const { getBooleanText } = useTranslationUi();
  const { singleItem, loading, contractType, statusTypes } =
    useSingleExtrastockOffer();

  const sections = useMemo(
    () =>
      getExtrastockOfferViewSections(t, singleItem, {
        contractType,
        statusTypes,
        getBooleanText,
      }),
    [t, singleItem, contractType, statusTypes, getBooleanText],
  );

  const pageTitle =
    singleItem?.['companies.title'] ||
    singleItem?.company?.title ||
    t('RICHIESTE EXTRASTOCK');

  const showEdit = singleItem?.can_update || singleItem?.can_approve;

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {showEdit && (
            <Col>
              <Button>
                <Link
                  to={`/facility/extrastock_offers/${singleItem?.id}/edit`}
                >
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/facility/extrastock_offers'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleExtrastockOffer;
